import styled, { css } from 'styled-components';
import { spacing, container, columns, breakPoints, mainNewsBreakpoints } from './constants';

export function BreakPoint(bp, render) {
    return css`
        @media only screen and (min-width: ${breakPoints[bp].width}px) {
            ${typeof render === 'function' ? render() : render}
        }
    `;
}

export function MainNewsBreakPoint(bp, render) {
    return css`
        @media only screen and (min-width: ${mainNewsBreakpoints[bp].width}px) {
            ${typeof render === 'function' ? render() : render}
        }
    `;
}

export function renderBreakPoints(render, mainNews = false) {
    if (mainNews) {
        return css`
            ${render(0, {
                spacing: spacing * 2
            })}

            ${Object?.values(mainNewsBreakpoints).map((bp, k) => {
                return css`
                    @media only screen and (min-width: ${bp.width}px) {
                        ${render(k, bp)}
                    }
                `;
            })}
        `;
    }
    return css`
        ${render(0, {
            spacing: spacing * 2
        })}

        ${Object?.values(breakPoints).map((bp, k) => {
            return css`
                @media only screen and (min-width: ${bp.width}px) {
                    ${render(k + 1, bp)}
                }
            `;
        })}
    `;
}

export function renderColSize(size, total) {
    if (size === 'hidden') {
        return css`
            display: none;
        `;
    }

    if (size === 'auto') {
        return css`
            display: block;
            flex: 0 0 auto;
            width: auto;
            max-width: none;
        `;
    }

    size = parseInt(size, 10);
    let percent = (100 / total) * size;

    return css`
        display: block;
        width: ${percent}%;
        flex: 0 0 ${percent}%;
    `;
}

export const Container = styled.div`
    width: 100%;
    max-width: ${({ fluid }) => (fluid ? '100%' : container + 'px')};
    clear: both;

    margin-right: auto;
    margin-left: auto;

    box-sizing: border-box;
    &:before,
    &:after {
        content: ' ';
        display: table;
    }
    &:after {
        clear: both;
    }

    padding-left: ${spacing * 2}px;
    padding-right: ${spacing * 2}px;

    ${props => {
        let px = props.px ? props.px.split(' ') : [];
        let pl = props.pl ? props.pl.split(' ') : [];
        let pr = props.pr ? props.pr.split(' ') : [];

        return renderBreakPoints(
            k => css`
                ${px[k] &&
                css`
                    padding-left: ${px[k] * spacing * 2}px;
                    padding-right: ${px[k] * spacing * 2}px;
                `}
                ${pl[k] &&
                css`
                    padding-left: ${pl[k] * spacing * 2}px;
                `}
        ${pr[k] &&
                css`
                    padding-right: ${pr[k] * spacing * 2}px;
                `}
            `
        );
    }}
`;

export const Row = styled.div`
    min-width: 100%;
    display: flex;
    flex-wrap: ${({ noWrap }) => (noWrap ? 'noWrap' : 'wrap')};

    height: auto;
    box-sizing: border-box;

    ${props => {
        let justifyContent = props.justifyContent ? props.justifyContent.split(' ') : [];
        let alignItems = props.alignItems ? props.alignItems.split(' ') : [];
        let direction = props.direction ? props.direction.split(' ') : ['row'];

        let mb = props.mb ? props.mb.split(' ') : ['0'];
        let mt = props.mt ? props.mt.split(' ') : ['0'];
        let pb = props.pb ? props.pb.split(' ') : ['0'];
        let pt = props.pt ? props.pt.split(' ') : ['0'];

        return renderBreakPoints(
            (k, bp) => css`
                ${justifyContent[k] &&
                css`
                    justify-content: ${justifyContent[k]};
                `}
                ${alignItems[k] &&
                css`
                    align-items: ${alignItems[k]};
                `}
        ${direction[k] &&
                css`
                    flex-direction: ${direction[k]};
                `}

        ${mb[k] &&
                css`
                    margin-bottom: ${parseFloat(mb[k]) * spacing}px;
                `}
        ${mt[k] &&
                css`
                    margin-top: ${parseFloat(mt[k]) * spacing}px;
                `}
        ${pt[k] &&
                css`
                    padding-top: ${parseFloat(pt[k]) * spacing}px;
                `}
        ${pb[k] &&
                css`
                    padding-bottom: ${parseFloat(pb[k]) * spacing}px;
                `}

        margin-left: -${bp.spacing}px;
                margin-right: -${bp.spacing}px;
            `
        );
    }}
`;

export const Col = styled.div`
    flex-basis: 0;
    flex-grow: 1;
    box-flex: 1;
    max-width: 100%;
    min-height: 1px;
    box-sizing: border-box;
    position: relative;
    padding-left: ${spacing * 2}px;
    padding-right: ${spacing * 2}px;

    ${props => {
        let grow = props.grow ? props.grow.split(' ') : [];
        let text = props.text ? props.text.split(' ') : [];
        let order = props.order ? props.order.split(' ') : [];
        let size = props.size ? props.size.split(' ') : [];

        let mb = props.mb ? props.mb.split(' ') : ['0'];
        let mt = props.mt ? props.mt.split(' ') : ['0'];
        let pb = props.pb ? props.pb.split(' ') : ['0'];
        let pt = props.pt ? props.pt.split(' ') : ['0'];

        let px = props.px ? props.px.split(' ') : ['1'];
        let pl = props.pl ? props.pl.split(' ') : [];
        let pr = props.pr ? props.pr.split(' ') : [];

        return renderBreakPoints(
            k => css`
                ${size[k] && renderColSize(size[k], columns)}
                ${grow[k] &&
                css`
                    flex-grow: ${grow[k]};
                `}
        ${text[k] &&
                css`
                    text-align: ${text[k]};
                `}
        ${order[k] &&
                css`
                    order: ${order[k]};
                `}

        ${mb[k] &&
                css`
                    margin-bottom: ${parseFloat(mb[k]) * spacing}px;
                `}
        ${mt[k] &&
                css`
                    margin-top: ${parseFloat(mt[k]) * spacing}px;
                `}
        ${pt[k] &&
                css`
                    padding-top: ${parseFloat(pt[k]) * spacing}px;
                `}
        ${pb[k] &&
                css`
                    padding-bottom: ${parseFloat(pb[k]) * spacing}px;
                `}

        ${px[k] &&
                css`
                    padding-left: ${px[k] * spacing * 2}px;
                    padding-right: ${px[k] * spacing * 2}px;
                `}

        ${pl[k] &&
                css`
                    padding-left: ${pl[k] * spacing * 2}px;
                `}
        ${pr[k] &&
                css`
                    padding-right: ${pr[k] * spacing * 2}px;
                `}
            `,
            props.mainNews
        );
    }}
`;

const Grid = {
    Container,
    Row,
    Col
};

export default Grid;
